// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1R7dC","actions":"GroupTable_actions__3818P","deleteModalFooter":"GroupTable_deleteModalFooter__23tAv"};